import { defineFeature } from '@/lib/platform/system';
import { clientMachine } from '@/features/client/state/client.machine';
import { taxrulesetMachine } from '@/features/taxruleset/state/taxruleset.machine';
import { filingcredentialMachine } from '@/features/filingcredential/state/filingcredential.machine';
import { filingMachine } from '@/features/filing/state/filing.machine';
import { statementMachine } from '@/features/statement/state/statement.machine';
import { approvalMachine } from '@/features/approval/state/approval.machine';
export const features = [
  defineFeature({
    id: 'client',
    machine: clientMachine,
    emits: ['client.registered'],
    handles: [],
    accepts: ['client.register', 'client.load-clients'],
  }),
  defineFeature({
    id: 'taxruleset',
    machine: taxrulesetMachine,
    emits: ['taxruleset.published'],
    handles: [],
    accepts: ['taxruleset.publish'],
  }),
  defineFeature({
    id: 'filingcredential',
    machine: filingcredentialMachine,
    emits: ['filingcredential.registered'],
    handles: [],
    accepts: ['filingcredential.register'],
  }),
  defineFeature({
    id: 'filing',
    machine: filingMachine,
    emits: ['filing.opened', 'filing.corrected', 'filing.rejected-corrected'],
    handles: [
      'client.registered',
      'taxruleset.published',
      'filingcredential.registered',
      'statement.handed-in',
      'approval.recorded',
    ],
    accepts: ['filing.load-filings', 'filing.load-review', 'filing.open', 'filing.correct', 'filing.correct-rejected'],
  }),
  defineFeature({
    id: 'statement',
    machine: statementMachine,
    emits: ['statement.handed-in'],
    handles: ['filing.opened'],
    accepts: ['statement.hand-in'],
  }),
  defineFeature({
    id: 'approval',
    machine: approvalMachine,
    emits: ['approval.recorded'],
    handles: ['filing.corrected', 'filing.rejected-corrected'],
    accepts: ['approval.record'],
  }),
] as const;
